<wiz-vgroup #daddy width="100%" height="100%" padding="0px">
  <wiz-vgroup #argsZone  width="100%" height="100%"  wizOverflow="auto">
    <wiz-checkbox #cbshowAll [wizLabel]="'$.tile.showonly.all.$'" (click)="toggleFilter($event)" ></wiz-checkbox>
    <wiz-hgroup #mainZone width="100%" height="100%">
      <!-- [style.width]=getSize(idx) -->
      <wiz-vgroup width="100%" height="100%" *ngFor="let idx of idxArr">
        <wiz-label class="smallFont" [wizLabel]="getData(idx).fdLabel" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        <wiz-ag-grid
          
          width="100%"
          height="100%"
          [wizDatasource]="getData(idx).wizDatasource"
          [wizRowSelection]="'multiple'"
          [columnDefs]="getData(idx).columnDefs"
          [widget]="getData(idx).parentWidget"
          [gridOptions]="gridOptions"
          class="ag-theme-alpine"
          ></wiz-ag-grid>
          <!-- [style.width]="getSize(idx)" -->

      </wiz-vgroup>
    </wiz-hgroup>

    <wiz-hgroup #mainZone width="100%" [horizontalAlign]="'end'">
      <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.generator.execute.$'" [iconPlacement]="'right'" width="200px" (wizClick)="doMe()"></wiz-button>
    </wiz-hgroup>

  </wiz-vgroup>
</wiz-vgroup>
